const tokens = {
  gray_0: '#FCFCFC',
  gray_20: '#F8F8F8',
  gray_25: '#F0F0F0',
  gray_50: '#DBDBDB',
  gray_75: '#C7C7C7',
  gray_100: '#BDBDBD',
  gray_200: '#AFAFAF',
  gray_300: '#999999',
  gray_400: '#646464',
  gray_500: '#444444',
  gray_600: '#3A3A3A',
  gray_700: '#333333',
  gray_800: '#2C2C2C',
  gray_900: '#232323',
  gray_1000: '#1E1E1E',
  gray_1050: '#191919',
  gray_1075: '#161616',
  gray_1100: '#111111',
  gray_1200: '#0A0A0A',
  mint_100: '#CEFFDC',
  mint_200: '#A0F2B6',
  mint_300: '#7FED9B',
  mint_400: '#61CF7C',
  mint_500: '#3C8455',
  mint_600: '#2E4D39',
  lavender_100: '#E6D3FF',
  lavender_200: '#D6B5FF',
  lavender_300: '#C99FFF',
  lavender_400: '#A173CD',
  lavender_500: '#63477E',
  lavender_600: '#3B3049',
  orchid_100: '#E6C7EB',
  orchid_200: '#E1A7EB',
  orchid_300: '#E393F1',
  orchid_400: '#C073CD',
  orchid_500: '#75467D',
  orchid_600: '#45294A',
  azure_100: '#CEE4FF',
  azure_200: '#9BC8FF',
  azure_300: '#7AB6FF',
  azure_400: '#407FCC',
  azure_500: '#264974',
  azure_600: '#1D3048',
  ocean_100: '#C2E2EF',
  ocean_200: '#92D4EF',
  ocean_300: '#63C9F4',
  ocean_400: '#40A2CC',
  ocean_500: '#27637D',
  ocean_600: '#173B4A',
  papaya_100: '#FFDECC',
  papaya_200: '#FFC4A3',
  papaya_300: '#FEA777',
  papaya_400: '#F37935',
  papaya_500: '#B2531E',
  papaya_600: '#453024',
  sunflower_100: '#FBE0B7',
  sunflower_200: '#FBD191',
  sunflower_300: '#FFBF5F',
  sunflower_400: '#F3A735',
  sunflower_500: '#7D561B',
  sunflower_600: '#4A3310',
  chartreuse_100: '#F9FDC1',
  chartreuse_200: '#F9FDC1',
  chartreuse_300: '#F4FD85',
  chartreuse_400: '#D2DB63',
  chartreuse_500: '#70753F',
  chartreuse_600: '#383A28',
  sapphire_100: '#C3EEE4',
  sapphire_200: '#A7EEDD',
  sapphire_300: '#7FEFD4',
  sapphire_400: '#5CD1B5',
  sapphire_500: '#26574B',
  sapphire_600: '#214A40',
  hibiscus_100: '#FFD4EA',
  hibiscus_200: '#FFB4DA',
  hibiscus_300: '#FF82C3',
  hibiscus_400: '#CC4E8E',
  hibiscus_500: '#93255E',
  hibiscus_600: '#691641',
  punch_100: '#F1C0CD',
  punch_200: '#FFAAC1',
  punch_300: '#FF6188',
  punch_400: '#D54166',
  punch_500: '#7D263C',
  punch_600: '#601528',
} as const;

export type PaletteToken = keyof typeof tokens;

const palette = {
  tokens,
  ...tokens,
  /**
   * @note avoid using hyphenated keys for semantic values as we delineate between literal
   * tokens and semantic values by using `-` vs `_`
   */
  semantic: {
    text: {
      primary: tokens.gray_0,
      secondary: tokens.gray_75,
      tertiary: tokens.gray_300,
      action: tokens.mint_300,
      action_hover: tokens.mint_400,
      error: tokens.punch_300,
    },
  },
};

export type SemanticText = keyof typeof palette.semantic.text;

export default palette;
